import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class GetRmDetailsUseCase extends BaseUseCase {
    constructor(RmDetailsRep) {
        super();
        this.RmDetailsRep = RmDetailsRep;
    }
    async fetchResult(req) {
        return await this.RmDetailsRep.getRmDetailsData(req);
    }
}
export default GetRmDetailsUseCase;
